import type {
  CreateCcDataResult,
  IAssemblyScreen,
  RotationControlSignals,
  SectionItemData,
} from 'gcf-player/shared-utils';

type MapScreensFn = (
  screens: Record<string, IAssemblyScreen>,
  components: Record<string, unknown>,
) => SectionItemData[];

// Takes the mapping function as an argument rather than importing it statically
// because the gcf-player remote is loaded asynchronously via
// useSharedUtilsFromGcfPlayer.
// Passes BOTH screens and components — without components, duration and
// videoCount on each SectionItemData will be zero (wrong rotation timing).
export const extractRotationItems = (
  previewData: CreateCcDataResult | undefined,
  mapScreens: MapScreensFn,
): SectionItemData[] => {
  const screens = previewData?.activeAssembly?.screens;
  if (!screens) {
    return [];
  }
  const components =
    (previewData?.ccData?.components as Record<string, unknown>) ?? {};

  return mapScreens(screens, components);
};

type PauseInPlaceSignals = Pick<RotationControlSignals, 'pause' | 'status'>;

export const pauseInPlace = (signals: PauseInPlaceSignals): void => {
  if (signals.status !== 'PLAYING') {
    return;
  }
  signals.pause();
};

export const getNextRotationPosition = (
  sorted: number[],
  current: number,
  direction: 'left' | 'right',
): number => {
  const idx = sorted.indexOf(current);
  if (idx === -1) return current;

  const nextIdx =
    direction === 'left'
      ? Math.max(0, idx - 1)
      : Math.min(sorted.length - 1, idx + 1);

  return sorted[nextIdx];
};
